var map = {
	"./fino.png": 9167,
	"./fino2.png": 5869,
	"./fino3.png": 1972,
	"./normal.png": 6464,
	"./normal2.png": 1440,
	"./normal3.png": 6265,
	"./normal4.png": 6438,
	"./sério.png": 5899,
	"./sério2.png": 3137,
	"./sério3.png": 424,
	"./zoião.png": 241,
	"./zoião2.png": 1815,
	"./zoião3.png": 8670,
	"./zoião4.png": 7153,
	"./zoião5.png": 6024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3972;